var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreReplenishmentIconBlue2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    stroke: "#5D5FEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50963_31349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7474 30.0703V21.5709C42.7476 21.0372 42.597 20.5142 42.3131 20.0624C42.0291 19.6105 41.6233 19.248 41.1423 19.0166L29.8826 13.3868C29.4804 13.1788 29.0342 13.0703 28.5814 13.0703C28.1286 13.0703 27.6824 13.1788 27.2802 13.3868L16.0177 19.0166C15.537 19.2482 15.1315 19.6108 14.8478 20.0626C14.5641 20.5145 14.4137 21.0373 14.4141 21.5709V37.1542C14.4141 37.9056 14.7126 38.6263 15.2439 39.1577C15.7753 39.689 16.4959 39.9875 17.2474 39.9875H23.2417",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9104 23.8302C28.9104 22.6279 28.4328 21.4748 27.5826 20.6247C26.7325 19.7745 25.5794 19.2969 24.3771 19.2969C23.1097 19.3016 21.8933 19.7962 20.9821 20.677L19.8438 21.8154M19.8438 21.8154V19.2969M19.8438 21.8154H22.3623M19.8438 23.8302C19.8438 25.0325 20.3214 26.1856 21.1715 27.0358C22.0217 27.8859 23.1748 28.3635 24.3771 28.3635C25.6444 28.3588 26.8609 27.8643 27.772 26.9834L28.9104 25.845M28.9104 25.845L26.3919 25.845M28.9104 25.845V28.3635",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.076 34.5476C43.0758 34.3027 43.0117 34.0622 42.8901 33.8501C42.7685 33.6381 42.5938 33.462 42.3834 33.3396L37.5353 30.5465C37.3247 30.4239 37.0859 30.3594 36.8427 30.3594C36.5996 30.3594 36.3607 30.4239 36.1501 30.5465L31.302 33.3396C31.0916 33.462 30.9169 33.6381 30.7953 33.8501C30.6737 34.0622 30.6096 34.3027 30.6094 34.5476V40.1338C30.6096 40.3787 30.6737 40.6192 30.7953 40.8313C30.9169 41.0433 31.0916 41.2194 31.302 41.3418L36.1501 44.1349C36.3607 44.2575 36.5996 44.322 36.8427 44.322C37.0859 44.322 37.3247 44.2575 37.5353 44.1349L42.3834 41.3418C42.5938 41.2194 42.7685 41.0433 42.8901 40.8313C43.0117 40.6192 43.0758 40.3787 43.076 40.1338V34.5476Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1094 33.8516L37.0934 37.3422L40.0854 35.5969L42.761 34.0361",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0938 44.3251V37.3438",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9766 32.5H26.4766",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9766 34.5H26.4766",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 36.5C25.7576 36.5 25.6955 36.5 26.4766 36.5",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50963_31349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(12.4766 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreReplenishmentIconBlue2);
export default __webpack_public_path__ + "static/media/StoreReplenishmentIconBlue2.cec2ba7ce1c8ff5fce89137d826b121f.svg";
export { ForwardRef as ReactComponent };